import styled from "@emotion/styled";

import { setFullViewportWidthStyles, theme } from "shared/lib/styles";

import { SCMPYoutubeVideo } from "scmp-app/components/scmp-youtube-video";

export const Container = styled.div`
  display: grid;
  grid-template:
    "video" max-content
    "headline" max-content;
  align-items: center;

  inline-size: 100%;
`;

export const StyledSCMPYoutubeVideo = styled(SCMPYoutubeVideo)`
  grid-area: video;

  margin-inline: auto;
  ${theme.breakpoints.only("mobile")} {
    ${setFullViewportWidthStyles()}
  }
`;
